import { ADD_DATA, GET_APP, GET_COMPANY, GET_COMPANY_DEPARTMENT, GET_ROLES, GET_ACTIVE, GET_VARIABLES, ADD_VARIABLES, UPDATE_VARIABLES, DEL_VARIABLES } from "@/api/role_template";
import querystring from "query-string";

const state = {
    list_active: [],
    list_variables: [],
    list_app: [],
    list_roles: [],
    list_company: [],
    list_company_department: [],
};

const mutations = {
    SET_LIST_VARIABLES: (state, payload) => {
        state.list_variables = payload;
    },
    SET_LIST_APP: (state, payload) => {
        state.list_app = payload;
    },
    SET_LIST_ACTIVE: (state, payload) => {
        state.list_active = payload;
    },
    SET_LIST_ROLES: (state, payload) => {
        state.list_roles = payload;
    },
    SET_LIST_COMPANY: (state, payload) => {
        state.list_company = payload;
    },
    SET_LIST_COMPANY_DEPARTMENT: (state, payload) => {
        state.list_company_department = payload;
    },
};

const actions = {
    GET_LIST_APP: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_APP(params);
        const data = resp.data.data;
        commit("SET_LIST_APP", data);
    },
    GET_LIST_ACTIVE: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_ACTIVE(params);
        const data = resp.data.data;
        commit("SET_LIST_ACTIVE", data);
    },

    GET_LIST_ROLES: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_ROLES(params);
        const data = resp.data.data.data;
        commit("SET_LIST_ROLES", data);
    },

    GET_LIST_COMPANY: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_COMPANY(params);
        const data = resp.data.data;
        commit("SET_LIST_COMPANY", data);
    },
    GET_LIST_COMPANY_DEPARTEMENT: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_COMPANY_DEPARTMENT(params);
        const data = resp.data.data;
        commit("SET_LIST_COMPANY_DEPARTMENT", data);
    },
    CREATE_DATA: async ({ }, args) => {
        return await ADD_DATA(args);
    },
    GET_LIST_VARIABLES: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_VARIABLES(params);
        const data = resp.data.result.data.rows;
        commit("SET_LIST_VARIABLES", data);
    },
    CREATE_VARIABLES: async ({ }, args) => {
        return await ADD_VARIABLES(args);
    },
    updateVariables: async ({ }, args) => {
        return await UPDATE_VARIABLES(args);
    },
    delVariables: async ({ }, id) => {
        return await DEL_VARIABLES(id);
    },

};

const getters = {
    listApp: (state) => state.list_app,
    listVariables: (state) => state.list_variables,
    listActive: (state) => state.list_active,
    listRoles: (state) => state.list_roles,
    listCompany: (state) => state.list_company,
    listCompanyDepartment: (state) => state.list_company_department,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
